<template>
<transition enter-active-class="ease-out duration-300 transition" enter-class="opacity-0" enter-to-class="opacity-100" leave-active-class="ease-in duration-200" leave-class="opacity-100" leave-to-class="opacity-0">
  <!-- This example requires Tailwind CSS v2.0+ -->
  <div class="fixed z-20 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="flex items-end justify-center min-h-full pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <!--
        Background overlay, show/hide based on modal state.

        Entering: "ease-out duration-300"
          From: "opacity-0"
          To: "opacity-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100"
          To: "opacity-0"
      -->
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

      <!--
        Modal panel, show/hide based on modal state.

        Entering: "ease-out duration-300"
          From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100 translate-y-0 sm:scale-100"
          To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      -->
      <div class="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
        <div class="block absolute top-0 right-0 pt-4 pr-4">
          <button type="button" @click="$emit('close')" class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
            <span class="sr-only">Close</span>
            <!-- Heroicon name: outline/x -->
            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div class="sm:flex sm:items-start">
          <!-- <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
            <InformationCircleIcon class="w-6 h-6 text-blue-600" />
          </div> -->
          <div class="sm:text-left">
            <h3 class="mr-10 text-lg leading-6 font-medium text-gray-900" id="modal-title">What does ‘Pay with Stripe’ mean?</h3>
            <PayWithStripeBadge :showInfoModalOnClick="false" class="mt-4" />
            <div class="mt-3 space-y-2 text-sm text-gray-500">
              <p>
                <!-- The ‘Pay with Stripe’ badge indicates that you can pay this tutor via a safe & secure, online payment page, powered by stripe.com. -->
                Tutors with the ‘Pay with Stripe’ badge accept payment via a safe & secure, online payment page, powered by stripe.com.
                Pay with confidence using your favourite payment method, including Apple Pay, Google Pay, American Express, Visa, Mastercard, and more.
              </p>
              <!-- <p>
                Read more about <a href="#" class="text-blue-600 underline">how ‘Pay with Stripe’ works</a> and the protection it offers over other payment methods.
              </p> -->
            </div>
          </div>
        </div>
        <!-- <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
          <button type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">Deactivate</button>
          <button type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm">Cancel</button>
        </div> -->
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import { InformationCircleIcon } from '@vue-hero-icons/outline'

export default {
  components: {
    InformationCircleIcon,
    PayWithStripeBadge: () => import('./PayWithStripeBadge.vue'),
  },
  props: {
    open: Boolean,
  }
}
</script>

<style>

</style>